import { useMutation } from "@tanstack/react-query";
import { postSendFollowupReminderForBusiness } from "apis";
import queryClient from "../../instances/react-query-client";
import { getAllQueuesQuery } from "./get-all-queues";

export const useSendFollowupReminder = () => {
  return useMutation(postSendFollowupReminderForBusiness, {});
};
